import { createStore } from 'zustand';
import { STYLES } from './lib';

export const createBrandStore = (dynamicBrand, siteLogo, siteLogoSecondary, siteFavicon, siteFont, siteFontSecondary, siteFontTertiary, siteOgImage) =>
  createStore((set) => ({
    themeView: 0,
    setThemeView: (themeView) => set(() => ({ themeView })),

    isLoading: false,
    setIsLoading: (isLoading) => set(() => ({ isLoading })),

    // Saved Brand ID
    id: dynamicBrand?.id || null,
    dynamicBrand,

    // Site Name
    siteName: dynamicBrand?.site_name || '',
    setSiteName: (siteName) => set(() => ({ siteName })),

    // Site Slogan
    siteSlogan: dynamicBrand?.site_slogan || '',
    setSiteSlogan: (siteSlogan) => set(() => ({ siteSlogan })),

    // Site Styles
    styles: { ...STYLES, ...dynamicBrand?.styles },
    setStyle: (styles) => set(() => ({ styles })),

    // Site Logo
    siteLogo: {
      filename: '',
      base64_file_data: '',
    },
    setSiteLogo: (siteLogo) => set(() => ({ siteLogo })),
    savedSiteLogo: siteLogo || '',
    setSavedSiteLogo: (savedSiteLogo) => set(() => ({ savedSiteLogo })),
    isDeleteSiteLogo: false,
    setIsDeleteSiteLogo: (isDeleteSiteLogo) => set(() => ({ isDeleteSiteLogo })),

    // Site Logo Secondary
    siteLogoSecondary: {
      filename: '',
      base64_file_data: '',
    },
    setSiteLogoSecondary: (siteLogoSecondary) => set(() => ({ siteLogoSecondary })),
    savedSiteLogoSecondary: siteLogoSecondary || '',
    setSavedSiteLogoSecondary: (savedSiteLogoSecondary) => set(() => ({ savedSiteLogoSecondary })),
    isDeleteSiteLogoSecondary: false,
    setIsDeleteSiteLogoSecondary: (isDeleteSiteLogoSecondary) => set(() => ({ isDeleteSiteLogoSecondary })),

    // Site Favicon
    siteFavicon: {
      filename: '',
      base64_file_data: '',
    },
    setSiteFavicon: (siteFavicon) => set(() => ({ siteFavicon })),
    savedSiteFavicon: siteFavicon || '',
    setSavedSiteFavicon: (savedSiteFavicon) => set(() => ({ savedSiteFavicon })),
    isDeleteSiteFavicon: false,
    setIsDeleteSiteFavicon: (isDeleteSiteFavicon) => set(() => ({ isDeleteSiteFavicon })),

    // Site Font
    siteFont: {
      filename: '',
      base64_file_data: '',
    },
    setSiteFont: (siteFont) => set(() => ({ siteFont })),
    savedSiteFont: siteFont || '',
    setSavedSiteFont: (savedSiteFont) => set(() => ({ savedSiteFont })),
    isDeleteSiteFont: false,
    setIsDeleteSiteFont: (isDeleteSiteFont) => set(() => ({ isDeleteSiteFont })),

    // Site Font Secondary
    siteFontSecondary: {
      filename: '',
      base64_file_data: '',
    },
    setSiteFontSecondary: (siteFontSecondary) => set(() => ({ siteFontSecondary })),
    savedSiteFontSecondary: siteFontSecondary || '',
    setSavedSiteFontSecondary: (savedSiteFontSecondary) => set(() => ({ savedSiteFontSecondary })),
    isDeleteSiteFontSecondary: false,
    setIsDeleteSiteFontSecondary: (isDeleteSiteFontSecondary) => set(() => ({ isDeleteSiteFontSecondary })),

    // Site Font Tertiary
    siteFontTertiary: {
      filename: '',
      base64_file_data: '',
    },
    setSiteFontTertiary: (siteFontTertiary) => set(() => ({ siteFontTertiary })),
    savedSiteFontTertiary: siteFontTertiary || '',
    setSavedSiteFontTertiary: (savedSiteFontTertiary) => set(() => ({ savedSiteFontTertiary })),
    isDeleteSiteFontTertiary: false,
    setIsDeleteSiteFontTertiary: (isDeleteSiteFontTertiary) => set(() => ({ isDeleteSiteFontTertiary })),

    // Site OG Image
    siteOgImage: {
      filename: '',
      base64_file_data: '',
    },
    setSiteOgImage: (siteOgImage) => set(() => ({ siteOgImage })),
    savedSiteOgImage: siteOgImage || '',
    setSavedSiteOgImage: (savedSiteOgImage) => set(() => ({ savedSiteOgImage })),
    isDeleteSiteOgImage: false,
    setIsDeleteSiteOgImage: (isDeleteSiteOgImage) => set(() => ({ isDeleteSiteOgImage })),
  }));
